import React from 'react';
import List from './List';

const InfiniteList = ({ canFetchMore, fetchMore, ...props }) => (
  <List
    {...props}
    onRowsRendered={({ stopIndex }) => stopIndex === props.rowCount - 1 && canFetchMore && fetchMore()}
  />
);

export default InfiniteList;
